import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgUserGroup = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.4136 13.3963C18.654 14.4308 20.1579 16.3442 20.1579 18.5335C20.1579 21.8222 5 21.8222 5 18.5335C5 16.3442 6.5039 14.4308 8.74435 13.3963C9.77491 14.2804 11.1146 14.8143 12.579 14.8143C14.0033 14.8143 15.3096 14.3092 16.3286 13.4682L16.4136 13.3963ZM12.579 5C14.9044 5 16.7895 6.88512 16.7895 9.21053C16.7895 11.5359 14.9044 13.4211 12.579 13.4211C10.2535 13.4211 8.36843 11.5359 8.36843 9.21053C8.36843 6.88512 10.2535 5 12.579 5Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M17.6622 10.3605C17.4902 11.124 17.1506 11.8239 16.6842 12.4198L16.8328 12.4884C18.047 13.0491 19.1065 13.8631 19.8729 14.8619C21.7644 14.617 23.25 14.0464 23.25 13.1501C23.25 11.5081 22.1338 10.0731 20.471 9.29722L20.4079 9.35119C19.6605 9.97448 18.7048 10.3518 17.6622 10.3605Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M5.22016 14.9477C2.9465 14.7753 1 14.1761 1 13.1501C1 11.5081 2.11617 10.0731 3.77901 9.29722C4.54388 9.96026 5.53816 10.3607 6.625 10.3607C6.91676 10.3607 7.20185 10.3318 7.47762 10.2768C7.64315 11.0728 7.99028 11.8022 8.47375 12.4198L8.32513 12.4884C7.07629 13.0651 5.99115 13.9097 5.22016 14.9477Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M9.52785 4.98627C8.21959 5.93286 7.36843 7.4723 7.36843 9.21053C7.36843 9.21565 7.36843 9.22077 7.36845 9.22589C7.13017 9.28465 6.88119 9.3158 6.625 9.3158C4.89911 9.3158 3.5 7.90196 3.5 6.1579C3.5 4.41384 4.89911 3 6.625 3C7.94123 3 9.06739 3.82231 9.52785 4.98627Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M17.7885 9.31155C17.7892 9.27795 17.7895 9.24428 17.7895 9.21053C17.7895 7.17855 16.6263 5.41824 14.9295 4.55907C15.4726 3.62615 16.4764 3 17.625 3C19.3509 3 20.75 4.41384 20.75 6.1579C20.75 7.84653 19.4384 9.2256 17.7885 9.31155Z", fill: props.fill }));
});
export default SvgUserGroup;
